let language = {
    USER_REGIST_OR_TEXT: "or",
    USER_REGIST_SIGNUP_WITH_EMAIL: "Sign up with your email",
    USER_REGIST_FORM_NICKNAME_LABEL: "Full Name",
    USER_REGIST_FORM_NICKNAME_PLACEHOLDER: "Please input your full name",
    USER_REGIST_FORM_EMAIL_LABEL: "Email",
    USER_REGIST_FORM_EMAIL_PLACEHOLDER: "Please input a valid email address",
    USER_REGIST_FORM_EMAIL_ERROR_TIP1: "Please enter the correct email address",
    USER_REGIST_FORM_PASSWORD_LABEL: "Password",
    USER_REGIST_FORM_PASSWORD_PLACEHOLDER: "Please enter password",
    USER_REGIST_FORM_PASSWORD_ERROR_TIP1: "Please input 8 to 20 characters,including uppercase,lowercase,numbers and symbols",
    USER_REGIST_FORM_REPEAT_PASSWORD_LABEL: "Confirm Password",
    USER_REGIST_FORM_REPEAT_PASSWORD_PLACEHOLDER: "Please check password",
    USER_REGIST_FORM_SUBMIT_BTN: "Sign Up",
    
    USER_REGIST_CONNECTION_ERROR_ALERT_TITLE: "Connection error",
};

export { language }